(ns frontend.view.webentry.templates.contact-schema
  (:require  [common.localization :as loc]))

(defonce contact-schema
  {:cards [{:card-name (loc/tr :contact-info)
             :card-key "contact-info"
             :fields [[{:field-name (loc/tr :contact/first-name)
                        :field-key "first-name"
                        :type "text"
                        :entity :contact
                        :attribute :contact/first-name
                        :size {:xs 12 :sm 6 :md 6}}
                       {:field-name (loc/tr :contact/last-name)
                        :field-key "last-name"
                        :type "text"
                        :entity :contact
                        :attribute :contact/last-name
                        :size {:xs 12 :sm 6 :md 6}}]
                      [{:field-name (loc/tr :contact/email)
                        :field-key "contact-email"
                        :type "email"
                        :entity :contact
                        :attribute :contact/email
                        :role? false
                        :size {:xs 12 :sm 12 :md 12}}]
                      [{:field-name (loc/tr :contact/phone)
                        :field-key "contact-phone"
                        :type "text"
                        :entity :contact
                        :attribute :contact/phone
                        :size {:xs 12 :sm 12 :md 12}}]
                      [{:field-name (loc/tr :contact/linkedin)
                        :field-key "contact-linkedin"
                        :type "url"
                        :entity :contact
                        :attribute :contact/linkedin
                        :size {:xs 12 :sm 12 :md 12}}]
                      [{:field-name (loc/tr :contact/spoken-to)
                        :field-key "contact-spoken-to"
                        :type "textarea"
                        :entity :contact
                        :attribute :contact/spoken-to
                        :size {:xs 12 :sm 12 :md 12}}]]}]})
